import { parseIceConfig, type RTCIceServerConfig } from '@remote/shared';

/**
 * Carga los servidores ICE de `/ice-servers.json`, servido junto al cliente desde
 * Firebase Hosting. Si no existe o está mal, cae al STUN por defecto.
 *
 * Nota de seguridad: este archivo es público, así que las credenciales TURN que
 * contenga lo son también. Para coturn, usa credenciales de tiempo limitado
 * (mecanismo REST/`use-auth-secret`), no una contraseña fija. El README lo explica.
 */
export async function loadIceServers(): Promise<RTCIceServerConfig[]> {
  try {
    const response = await fetch('/ice-servers.json', { cache: 'no-store' });
    if (!response.ok) return parseIceConfig(null);
    const parsed: unknown = await response.json();
    return parseIceConfig(parsed);
  } catch {
    // Sin archivo (404 en dev, o red caída): STUN por defecto.
    return parseIceConfig(null);
  }
}
